import React, { useState } from 'react';
import { Tree } from 'antd';

const CommonTree = ({ treeData, row, addChild, opneEditParent, deleteOpenModal, deleteParentPassword, deleteChildPassword, restoreChild, searchableChild, pageLayoutData }) => {
  const [rowInfo, setRowInfo] = useState(null);

  const recursiveActions = (data) => (
    <div
    className='tree-node-wrapper'
    onMouseEnter={(e) => {
      e.currentTarget.style.backgroundColor = '#f5f5f5';
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.backgroundColor = '#fff';
    }}
    >
      <div style={{ display: 'flex', flexDirection: 'column' }}>
      <div style={{ fontWeight: '600', fontSize: '14px' }}>
        {data.title}
      </div>
      <div style={{ fontSize: '12px', color: '#888', marginTop: '2px' }}>
        {data.subtitle}
      </div>
    </div>
      <span className='feature-actions' style={{ display: 'flex', fontSize: '16px', color: '#555' }}>
        {/* {data.add && <i className="fa fa-plus-square-o fa-add" aria-hidden="true" onClick={() => addChild(row, data)} />} */}
        {((data.add || data[`add${pageLayoutData[0].hasOwnProperty('addButtonName') && pageLayoutData[0].addButtonName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonName.replace(/\s+/g, '') : pageLayoutData[0].addButtonName}Permission`] === true))
          && (<i className="fa fa-plus-square-o fa-add" aria-hidden="true" onClick={() => addChild(row, data)} />)}
        {( data.edit == true || data[`edit${pageLayoutData[0].hasOwnProperty('addButtonName') && pageLayoutData[0].addButtonName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonName.replace(/\s+/g, '') : pageLayoutData[0].addButtonName}Permission`] === true  ) 
          && <i className="fa fa-edit" aria-hidden="true" onClick={() => opneEditParent(row, data)} />}
        {data.del && <i className="fa fa-trash-o" aria-hidden="true" onClick={() => deleteOpenModal(row, data)} />}
        {data.delParent && <i className="fa fa-trash-o" aria-hidden="true" onClick={() => deleteParentPassword(row, data)} />}
        {data.delChild && <i className="fa fa-trash-o" aria-hidden="true" onClick={() => deleteChildPassword(row, data)} />}
        {data.restore && <i className="fa fa-recycle" aria-hidden="true" onClick={() => restoreChild(row, data)} />}
        {data.search && <i className="fa fa-search-minus" aria-hidden="true" onClick={() => searchableChild(row, data)} />}
        {data.search == false && <i className="fa fa-search-plus" aria-hidden="true" onClick={() => searchableChild(row, data)} />}
      </span>
    </div>
  );

  const modifyTreeData = (data) => {
    return data.map((item) => {
     return {
      ...item,
      title: recursiveActions(item),
      children: item.children ? modifyTreeData(item.children) : undefined
    }});
  };

  const modifiedTreeData = modifyTreeData(treeData);
  return (
    <Tree
      showLine
      treeData={modifiedTreeData}
      virtual={true}
      onSelect={(selectedKeys, info) => { setRowInfo(info) }}
    />
  );
};

export default CommonTree;
